import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const IconButtonContainer = styled.div`
  width: 3.2rem;

  color: ${({ theme }) => theme.palette.text.secondary};
`;
